/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Not_Found_TitleInputs */

const en_endpoint_not_found_title = /** @type {(inputs: Endpoint_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint not found`)
};

const zh_hans1_endpoint_not_found_title = /** @type {(inputs: Endpoint_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到接口`)
};

const pt_br2_endpoint_not_found_title = /** @type {(inputs: Endpoint_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint não encontrado`)
};

const es_endpoint_not_found_title = /** @type {(inputs: Endpoint_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint no encontrado`)
};

const fr_endpoint_not_found_title = /** @type {(inputs: Endpoint_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint introuvable`)
};

const de_endpoint_not_found_title = /** @type {(inputs: Endpoint_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint nicht gefunden`)
};

const ru_endpoint_not_found_title = /** @type {(inputs: Endpoint_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эндпоинт не найден`)
};

const it_endpoint_not_found_title = /** @type {(inputs: Endpoint_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint non trovato`)
};

/**
* | output |
* | --- |
* | "Endpoint not found" |
*
* @param {Endpoint_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_not_found_title = /** @type {((inputs?: Endpoint_Not_Found_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Not_Found_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_not_found_title(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_not_found_title(inputs)
	if (locale === "es") return es_endpoint_not_found_title(inputs)
	if (locale === "fr") return fr_endpoint_not_found_title(inputs)
	if (locale === "de") return de_endpoint_not_found_title(inputs)
	if (locale === "ru") return ru_endpoint_not_found_title(inputs)
	if (locale === "it") return it_endpoint_not_found_title(inputs)
	return en_endpoint_not_found_title(inputs)
});